import { render } from "./BridgeClock2.vue?vue&type=template&id=4163f0cd&scoped=true"
import script from "./BridgeClock2.vue?vue&type=script&lang=js"
export * from "./BridgeClock2.vue?vue&type=script&lang=js"

import "./BridgeClock2.vue?vue&type=style&index=0&id=4163f0cd&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4163f0cd"]])

export default __exports__